import { render, staticRenderFns } from "./PodrucjeTemeCreate.vue?vue&type=template&id=513b6981&scoped=true&"
import script from "./PodrucjeTemeCreate.vue?vue&type=script&lang=js&"
export * from "./PodrucjeTemeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b6981",
  null
  
)

export default component.exports